import { ComponentBase } from '../components/ComponentBase';
import { template } from '../utils/TemplateParser';
import { lang } from '../lang';
import { vars } from '../utils/vars';
import { api } from '../utils/api';
import { load as loadCAPTCHA } from 'recaptcha-v3';

export class RegistrationConfirmation extends ComponentBase {
    constructor({id, attendeeId, action, code, model}) {
        super({ id: 'registration-confirmation', class: 'confirmation-page' });
        this.id = id;
        this.attendeeId = attendeeId;
        this.action = action;
        this.code = code;

        this.model = model;
        this.eventRoute = `event-details/${id}`;
        this.render();
        this.submitRegistration();
    }

    template() {
        return template`
            <div class="hero">
                <div class="wrapper">
                    <div class="controls">
                        <h1 class="page-title" id="public-submission-page-title">${lang.RegistrationConfirmationTitle}</h1>
                    </div>
                </div>
            </div>
            <div class="wrapper">
                <div role="region" class="page" aria-labelledby="public-submission-page-title">
                    <div class="container">

                    </div>
                </div>
            </div>
        `
    }

    confirmationTemplate() {
        return template`
            <div class="confirmation-page-message registration-confirmation-message">
                <h3>${lang.RegistrationConfirmationHeader}</h3>
                <p>${lang.RegistrationConfirmationMessage}</p>
                <a href="${this.getRouteURL(this.eventRoute)}" data-action="routeChange">${lang.ReturnToEventDetails}</a>
            </div>
        `;
    }

    expiredLinkTemplate() {
        return template`
            <div class="confirmation-page-message expired-link-message">
                <h3>${lang.RegistrationLinkExpiredHeader}</h3>
                <p>${lang.RegistrationLinkExpiredMessage}</p>
                <a href="${this.getRouteURL(this.eventRoute)}" data-action="routeChange">${lang.ReturnToEventDetails}</a>
            </div>
        `;
    }

    cancelationTemplate() {
        return template`
            <div class="confirmation-page-message cancelation-message">
                <h3>${lang.RegistrationCancelationHeader}</h3>
                <a href="${this.getRouteURL(this.eventRoute)}" data-action="routeChange">${lang.ReturnToEventDetails}</a>
            </div>
        `;
    }

    cancelationLinkExpiredTemplate() {
        return template`
            <div class="confirmation-page-message cancelation-link-expired-message">
                <h3>${lang.RegistrationLinkExpiredHeader}</h3>
                <p>${lang.RegistrationCancelationLinkExpiredMessage}</p>
                <a href="${this.getRouteURL(this.eventRoute)}" data-action="routeChange">${lang.ReturnToEventDetails}</a>
            </div>
        `;
    }

    // Make API call to submit registration, then display confirmation if successful or expired link if not
    submitRegistration() {
        const data = {
            'event-id': this.id,
            attendee: this.attendeeId,
            code: this.code,
        };

        if (this.action !== 'REGISTER') {
            data.action = this.action;
        }

        // Add page URL and hash boolean to data
        data.hash = window.location.hash ? true : false;
        data.url = api.getURL();


        const options = {
            useRecaptchaNet: true,
            autoHideBadge: true,
        };

        loadCAPTCHA(vars.pubcalendar.captchaSiteKey, options).then(recaptcha => {
            recaptcha.execute('confirm_attendee').then(token => {
                data.token = token;

                api.confirmAttendee(data).then(response => {
                    this.#getEventInfo('success');
                })
                .catch(response => {
                    this.#getEventInfo('expired');
                });

            });
        });
    }

    #getEventInfo(result) {
        api.getEvent({id: this.id}).then(data => {
            this.model = data;
            // If event is recurring, change event details link to series overview
            if (this.model.recurring) {
                this.eventRoute = `event-details/${this.id}/series-overview`;
            }
            if (result === 'success') {
                this.#displayConfirmation();
            }
            else if (result === 'expired') {
                this.#displayExpiredLink();
            }
        });
    }

    #displayConfirmation() {
        if (this.action === 'CANCEL') {
            this.renderInto(this.cancelationTemplate(), this.el.querySelector('.container'));
        }
        else if (this.action === 'REGISTER') {
            this.renderInto(this.confirmationTemplate(), this.el.querySelector('.container'));
        }
    }

    #displayExpiredLink() {
        if (this.action === 'CANCEL') {
            this.renderInto(this.cancelationLinkExpiredTemplate(), this.el.querySelector('.container'));
        }
        else if (this.action === 'REGISTER') {
            this.renderInto(this.expiredLinkTemplate(), this.el.querySelector('.container'));
        }
    }
}